import { Component, Input } from '@angular/core';

@Component({
  selector: 'tangram-tangram-preview',
  templateUrl: './tangram-preview.component.html',
  styleUrls: ['./tangram-preview.component.scss']
})
export class TangramPreviewComponent {
  @Input() items: Array<{ title: string; editable: boolean; link?: string }> = [];
}
